import { render, staticRenderFns } from "./RecyclerDataTable.vue?vue&type=template&id=3547139f&scoped=true"
import script from "./RecyclerDataTable.vue?vue&type=script&lang=js"
export * from "./RecyclerDataTable.vue?vue&type=script&lang=js"
import style0 from "./RecyclerDataTable.vue?vue&type=style&index=0&id=3547139f&prod&scoped=true&lang=css"
import style1 from "./RecyclerDataTable.vue?vue&type=style&index=1&id=3547139f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3547139f",
  null
  
)

export default component.exports